import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { Outlet } from 'react-router';
import { Sidebar } from '../components/layout/Sidebar';
import { TopBar } from '../components/layout/TopBar';
import { useDvms } from '../state/dvmsStore';
import { useIsLoading } from '../hooks/useIsLoading';

export function AppShell() {
    const { state } = useDvms();
    const isLoading = useIsLoading();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
            {/* Global API loading bar — fixed at the very top of the viewport */}
            <LinearProgress
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 9999,
                    height: 2,
                    visibility: isLoading ? 'visible' : 'hidden',
                }}
            />
            <TopBar />
            <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                <Sidebar />
                <Box
                    component="main"
                    sx={{
                        flex: 1,
                        overflow: 'auto',
                        bgcolor: 'background.default',
                        minWidth: 0,
                    }}
                >
                    {state.status === 'error' && (
                        <Box sx={{ p: 4 }}>
                            <Alert severity="error">Failed to load data: {state.error}</Alert>
                        </Box>
                    )}
                    <Outlet />
                </Box>
            </Box>
            <Snackbar
                open={Boolean(state.mutationSuccess)}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity="success" variant="filled" sx={{ width: '100%' }}>
                    {state.mutationSuccess}
                </Alert>
            </Snackbar>
            <Snackbar
                open={Boolean(state.mutationError)}
                autoHideDuration={5000}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity="error" variant="filled" sx={{ width: '100%' }}>
                    Failed to save: {state.mutationError}
                </Alert>
            </Snackbar>
        </Box>
    );
}
